export default __webpack_public_path__ + "static/media/fathersday.fc913c2dabc58380e46570030605254f.svg";